<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { computed, onMounted } from 'vue'
import { useRouter } from '#imports'
import useOidc from '~/composables/useOidc'
import Button from '~/components/ui/Button.vue'
import AuSpinner from '~/components/ui/AuSpinner.vue'
import AuCallout from '~/components/ui/AuCallout.vue'

const { t } = useI18n()
const router = useRouter()
const { loginRedirect, saveRedirectUri, getRedirectUri, isLoading, hasError } = useOidc()

const redirectUri = computed(() => String(router.currentRoute.value.query?.redirectUri ?? getRedirectUri()))

onMounted(() => {
  saveRedirectUri(redirectUri.value)
  loginRedirect()
})
</script>

<template>
  <div
    v-if="isLoading"
    class="absolute inset-0 flex items-center justify-center"
  >
    <AuSpinner />
  </div>
  <div
    v-else-if="hasError"
    class="font-inter mx-1 mt-20 mb-12 rounded-xl p-6 max-md:px-4 sm:mx-4 lg:mx-auto lg:max-w-screen-lg"
  >
    <AuCallout
      :title="t('login.error.title')"
      variant="error"
    >
      {{ t('login.error.unknown') }}
    </AuCallout>
    <Button
      class="mt-6"
      href="/"
      variant="outline"
    >
      {{ t('back') }}
    </Button>
  </div>
</template>
